import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MainList from './MainList';
import SecondaryList from './SecondaryList';
import HelmetFont from './HelmetFont';

import styles from './HorizontalNavigation.css';

const HorizontalNavigation = ({
  activeItem,
  hasOpenedSidebar,
  navigationItems,
}) => (
  <Fragment>
    <HelmetFont />
    <nav className={styles.mainList} key="main">
      <MainList
        activeItem={activeItem}
        hasOpenedSidebar={hasOpenedSidebar}
        navItems={navigationItems.main}
      />
    </nav>
    {navigationItems.secondary.length > 0 && (
      <nav
        className={classNames(styles.secondaryList, {
          [styles.navVisible]: hasOpenedSidebar,
        })}
        key="secondary"
      >
        <SecondaryList
          activeItem={activeItem}
          sections={navigationItems.secondary}
        />
      </nav>
    )}
  </Fragment>
);

HorizontalNavigation.displayName = 'HorizontalNavigation';

HorizontalNavigation.defaultProps = {
  activeItem: 'home', // Home page key as default Active Item
};
HorizontalNavigation.propTypes = {
  activeItem: PropTypes.string,
  hasOpenedSidebar: PropTypes.bool.isRequired,
  navigationItems: PropTypes.shape({
    main: PropTypes.array.isRequired,
    secondary: PropTypes.arrayOf(PropTypes.array).isRequired,
  }).isRequired,
};

export default HorizontalNavigation;
